import { Calendar, Sparkles, Package, ShieldCheck, Globe } from "lucide-react";
import { siteContent } from "../../data/content";

const iconMap = {
  Calendar,
  Sparkles,
  Package,
  ShieldCheck,
  Globe,
};

export const TrustBar = () => {
  return (
    <section className="bg-charcoal-paper border-y border-white/5 py-8">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {siteContent.trustHighlights.map((item, index) => {
            const Icon = iconMap[item.icon];
            return (
              <div
                key={index}
                className="flex flex-col items-center text-center gap-2"
                data-testid={`trust-item-${index}`}
              >
                <div className="w-12 h-12 bg-charcoal-subtle border border-white/5 flex items-center justify-center">
                  {Icon && <Icon className="w-5 h-5 text-coconut" />}
                </div>
                <span className="text-sm font-medium text-zinc-300">{item.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
